export const ADDPRODUCTTOCART = "cartItems/addItemToCart";
export const REMOVEPRODUCTTOCART = "cartItems/removeItemToCart";
export const HANDLECARTITEMQUENTITY = "productItems/HandleCartItemQuantity";